import { UserActionTypes, UserPayload } from "@fkhplus/common/src/modules/user/actions";
import { IFluxStandardAction } from "@fkhplus/common/src/modules/interfaces";
import { ISetUserResponse } from "@fkhplus/common/src/modules/user/interfaces";

export const initialState: ISetUserResponse = {
    isLoggedIn : false,
    error : ''
};

export const UserReducer = (
    state: ISetUserResponse = initialState, 
    action: IFluxStandardAction<UserPayload>) : ISetUserResponse => {
    switch(action.type) {
        case UserActionTypes.IS_LOGGED_IN :
            return{
                ...state,
                ['isLoggedIn']: action.payload as boolean
            };

        default:
            return state;
    }
};
